<template>
	<div class="bread-section">
		<el-breadcrumb separator="/" class="el-bread">
			<el-breadcrumb-item v-for="({meta: { title }}, index) of $route.matched" :key="index">
				<span :class="addAnimationClass(index)">{{ title }}</span>
			</el-breadcrumb-item>
		</el-breadcrumb>
	</div>
</template>

<script lang="ts" setup>
	import { computed, ref, watch } from "vue"
	import { useRouter, useRoute } from 'vue-router'
	
	const router = useRouter()
	const route = useRoute()
	
	const show = ref(false)
	const timer:Timeout = ref(null)
	const addAnimationClass = computed(() => {
		return (index:number) => {
			if(index + 1 === route.matched.length && show.value){
				return 'new'
			}
		}
	})
</script>

<style scoped lang="scss">
	.el-bread{
		padding: 0 20px;
		height: var(--bread-height);
		line-height: var(--bread-height);
		:last-child span{
			font-size: 16px;
			color: #333;
			font-weight: 700;
		}
	}
</style>